// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100vh;
}
 
.error-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 20px;
    animation: rotate 2s linear infinite;
    /* CSS animation */
}
 
.error-message {
    font-size: 20px;
    color: red;
}
 
@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
 
    100% {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/ErrorMessage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".error-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    height: 100vh;\n}\n \n.error-icon {\n    width: 50px;\n    height: 50px;\n    margin-bottom: 20px;\n    animation: rotate 2s linear infinite;\n    /* CSS animation */\n}\n \n.error-message {\n    font-size: 20px;\n    color: red;\n}\n \n@keyframes rotate {\n    0% {\n        transform: rotate(0deg);\n    }\n \n    100% {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
